import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { RedFlag } from '../../../../static/img/images'
import { fetchClassSubtopicOverallReport, fetchSchoolSubtopicOverallReport, selectClass, selectStudent, subtopicReportReset } from '../../../../store/actions'
import './style.scss'
import { textIdentifier } from '../../../../textIdentifier'

function CustomPaginatedTable(props) {
    const [pageSize, setPageSize] = useState(10)
    const [pageNumber, setpageNumber] = useState(0)
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { selectedCompetition, selectedSchool, selectedClass, lang  } = useSelector(
        (state) => state.main
      );
    const goPrevious = () => {
        dispatch(fetchClassSubtopicOverallReport({
            classId: selectedClass.code,
            nodeId: props.activeTopic.nodeId,
            params: {
              limit: pageSize,
              offset: Number((pageNumber-1)*pageSize)
            },
            activeTopicData: {
              name: props.activeTopic.name,
              totalMarks: props.activeTopic.totalMarks,
              totalQuestions: props.activeTopic.totalQuestions,
              nodeId: props.activeTopic.nodeId,
            }
        }))
        setpageNumber(pageNumber-1)
    }

    const goNext = () => {
        dispatch(fetchClassSubtopicOverallReport({
            classId: selectedClass.code,
            nodeId: props.activeTopic.nodeId,
            params: {
              limit: pageSize,
              offset: Number((pageNumber+1)*pageSize)
            },
            activeTopicData: {
              name: props.activeTopic.name,
              totalMarks: props.activeTopic.totalMarks,
              totalQuestions: props.activeTopic.totalQuestions,
              nodeId: props.activeTopic.nodeId,
            }
        }))
        setpageNumber(pageNumber+1)
    }

    const handleNameClick = (data) => {
        // let len = props.data.results.length
        // dispatch(selectClass({ code: data.class_code }))
        // dispatch(selectStudent({ ...data, len }));
        // navigate(`/report/${selectedCompetition.id}/schools/${selectedSchool.id}/classes/${data.class_code}/students/${data.student_id}`);
        navigate(`/report/${selectedCompetition.id}/schools/${selectedSchool.id}/classes/${data.class_code}/students?student=${data.student_id}`);
        dispatch(subtopicReportReset())
    }

    const handlePageSizeChange = (size) => {
        setPageSize(size)
        dispatch(fetchClassSubtopicOverallReport({
            classId: selectedClass.code,
            nodeId: props.activeTopic.nodeId,
            params: {
              limit: size,
              offset: 0
            },
            activeTopicData: {
              name: props.activeTopic.name,
              totalMarks: props.activeTopic.totalMarks,
              totalQuestions: props.activeTopic.totalQuestions,
              nodeId: props.activeTopic.nodeId,
            }
        }))
        setpageNumber(0)
    }

  return (
    <div className="custom--table--wrapper">
        <div className="info--wrapper">
            <div className="info--card">
                <p>{textIdentifier["topic-name"][lang]}: <b>{!!props.activeTopic && props.activeTopic.name}</b></p>
                <p>{textIdentifier["total-questions"][lang]} = <b>{!!props.activeTopic && props.activeTopic.totalQuestions}</b></p>
                <p>{textIdentifier["total-marks"][lang]} = <b>{!!props.activeTopic && props.activeTopic.totalMarks}</b></p>
            </div>
            <div className="list--length--select">
                <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
                    <path d="M7.5 6C7.5 6.39782 7.34196 6.77936 7.06066 7.06066C6.77936 7.34196 6.39782 7.5 6 7.5C5.60218 7.5 5.22064 7.34196 4.93934 7.06066C4.65804 6.77936 4.5 6.39782 4.5 6C4.5 5.60218 4.65804 5.22064 4.93934 4.93934C5.22064 4.65804 5.60218 4.5 6 4.5C6.39782 4.5 6.77936 4.65804 7.06066 4.93934C7.34196 5.22064 7.5 5.60218 7.5 6V6Z" stroke="#0059B1" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M1.229 6C1.866 3.9715 3.7615 2.5 6 2.5C8.239 2.5 10.134 3.9715 10.771 6C10.134 8.0285 8.239 9.5 6 9.5C3.7615 9.5 1.866 8.0285 1.229 6V6Z" stroke="#0059B1" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                <select
                    value={pageSize}
                    onChange={e => {
                        handlePageSizeChange(Number(e.target.value))
                    }}
                    >
                    {[10,25,50].map(pageSize => (
                        <option key={pageSize} value={pageSize}>
                        {pageSize}
                        </option>
                    ))}
                </select>
            </div>
        </div>
        <table>
            <thead>
                <tr>
                    <th>{textIdentifier["students"][lang]}</th>
                    <th >{textIdentifier["proficiency"][lang]}  % <span className='formula'>({textIdentifier["marks-obtained"][lang]}/<br/>{textIdentifier["highest-mark-possible"][lang]})</span></th>
                    <th>{textIdentifier["marks-obtained"][lang]}</th>
                    <th style={{display:"flex",flexDirection:"column",alignItems:"center", height:"auto", width:"auto"}}>{textIdentifier["accuracy"][lang]} (%) <span className='formula'>({textIdentifier["question-correct"][lang]}/<br/>{textIdentifier["question-attempted"][lang]})</span></th>
                    <th>{textIdentifier["question-correct"][lang]}</th>
                    <th>{textIdentifier["question-attempted"][lang]}</th>
                </tr>
            </thead>
            <tbody>
                {
                    ("results" in props.data)
                    &&
                    props.data.results.map((item,index)=>(
                        <tr>
                            <td>
                                <div onClick={()=>{handleNameClick(item)}} className="data--cell topic--name--wrapper">
                                <div className="topic--name">
                                {`${item.student_first_name} ${item.student_last_name}`}
                                </div>
                                {
                                    index<5 && pageNumber==0
                                    &&
                                    <RedFlag/>
                                }
                                </div>
                            </td>
                            <td>{`${item.proficiency}%`}</td>
                            <td>{`${item.marks}`}</td>
                            <td>{`${item.accuracy}%`}</td>
                            <td>{`${item.questions_correct}`}</td>
                            <td>{`${item.questions_attempted}`}</td>
                        </tr>
                    ))
                }
            </tbody>
        </table>
        <div className='pagination'>
          <button onClick={() => {goPrevious()}} disabled={pageNumber==0 && (!!props.data && props.data.previous==null)}>
            &#10094;{' '}
            {textIdentifier["previous-page"][lang]}
          </button>{' '}
          <button onClick={() => {goNext()}} disabled={!!props.data && props.data.next==null}>
          {textIdentifier["next-page"][lang]}{' '}
            &#10095;
          </button>{' '}

        </div>
    </div>
  )
}

export default CustomPaginatedTable